module.exports = __webpack_public_path__ + "img/Publish-My-Website-en.bdbfd68.png";